import { Box, Button, Typography } from "@mui/material";
import header from "../../../../assets/hero.png";
import heroMobile from "../../../../assets/heroMob.png";
import { useNavigate } from "react-router";
import FadeInBox from "../../../../commonComponents/FadeInBox";

const Header = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        component="img"
        alt="import and export"
        src={window.innerWidth < 768 ? heroMobile : header}
        sx={{
          width: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(to right, rgba(22, 75, 124, 0.7) 20%, rgba(22, 75, 124, 0.4) 60%, rgba(22, 75, 124, 0) 70%)",
          zIndex: 0.5,
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: { xs: "50%", md: "50%" },
          left: { xs: "50%", md: "30%" },
          transform: "translate(-50%, -50%)",
          color: "#FFFFFF",
          width: { xs: "80%", md: "70%", lg: "40%" },
          zIndex: 1,
        }}
      >
        <FadeInBox delay={0.2}>
          <Typography
            sx={{
              fontSize: { xs: "16px", sm: "20px", md: "30px", lg: "34px" },
              fontWeight: 700,
              fontFamily: "Montserrat",
              mb: { xs: 2, md: 3 },
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
            }}
          >
            Delivering Quality Medical & Commercial Products Through UK Trade,
            Distribution & Global Partnerships
          </Typography>
        </FadeInBox>
        <FadeInBox delay={0.4}>
          <Typography
            sx={{
              fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "18px" },
              fontWeight: 500,
              fontFamily: "Montserrat",
              mb: { xs: 3, md: 4 },
              textShadow: "1px 1px 3px rgba(0, 0, 0, 0.5)",
            }}
          >
            A UK-based import, export, and trading agency supplying hospitals,
            distributors, and business partners across the United Kingdom and
            international markets.
          </Typography>
        </FadeInBox>
        <FadeInBox delay={0.6}>
          <Button
            variant="contained"
            onClick={() => navigate("/contact-us")}
            sx={{
              backgroundColor: "#FFFFFF",
              color: "#164B7C",
              fontSize: { xs: "10px", md: "16px" },
              fontWeight: 600,
              padding: { xs: "8px 20px", md: "12px 32px" },
              textTransform: "none",
              fontFamily: "Montserrat",
              "&:hover": {
                backgroundColor: "#164B7C",
                color: "#FFFFFF",
              },
            }}
          >
            Partner With El Deeb UK{" "}
          </Button>
        </FadeInBox>
      </Box>
    </Box>
  );
};

export default Header;
